import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/my/creators/{creatorId}/user-profile-tabs';

export type UserProfileTabsApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

export const useUserProfileTabs = (
  params: UserProfileTabsApi['params'] | null,
  config?: UseNoodleSwrConfig<UserProfileTabsApi['response']>,
): SWRResponse<UserProfileTabsApi['response'], ApiError> => {
  const path = params ? buildPath<UserProfileTabsApi>(PATH_TEMPLATE, params) : null;
  return useNoodleSwr(path, { revalidateOnFocus: false, ...config });
};

/**
 * @deprecated: Please use `useUserProfileTabs` wherever a perfectly fresh response is not worth the network time, bandwidth, and compute.
 */
const getUserProfileTabs = async ({
  creatorId,
}: UserProfileTabsApi['params']): Promise<UserProfileTabsApi['response']> => {
  const path = buildPath<UserProfileTabsApi>(PATH_TEMPLATE, { creatorId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getUserProfileTabs;
